import React from 'react';
import PropTypes from 'prop-types';
import MarkdownParser from './utilities/MarkdownParser';
import OwnerAndTime from './utilities/OwnerAndTime';
import LikeDislikeButton from './utilities/LikeDislikeButton';

export default function ThreadCard({
  owner,
  avatar,
  createdAt,
  content,
  likeCount,
  dislikeCount,
  liked,
  disliked,
  onToggleLike,
  onToggleDislike,
}) {
  return (
    <div className="px-6 py-4 rounded-lg bg-zinc-100 dark:bg-zinc-900/50 mb-8">
      <OwnerAndTime
        owner={owner}
        avatar={avatar}
        createdAt={createdAt}
        wrapperClass="mb-4 "
      />
      <MarkdownParser content={content} className="mb-8" />
      <LikeDislikeButton
        likeCount={likeCount}
        dislikeCount={dislikeCount}
        liked={liked}
        disliked={disliked}
        onToggleLike={onToggleLike}
        onToggleDislike={onToggleDislike}
      />
    </div>
  );
}

ThreadCard.propTypes = {
  /** The owner name */
  owner: PropTypes.string.isRequired,
  /** The owner avatar */
  avatar: PropTypes.string.isRequired,
  /** ISO 8601 Date format */
  createdAt: PropTypes.string.isRequired,
  /** Content of the thread */
  content: PropTypes.string.isRequired,
  /** Count of liked user to the thread */
  likeCount: PropTypes.number.isRequired,
  /** Count of disliked user to the thread */
  dislikeCount: PropTypes.number.isRequired,
  /** Liked by the logged in user */
  liked: PropTypes.bool,
  /** Disliked by the logged in user */
  disliked: PropTypes.bool,
  /** Toggle like action */
  onToggleLike: PropTypes.func.isRequired,
  /** Toggle dislike action */
  onToggleDislike: PropTypes.func.isRequired,
};

ThreadCard.defaultProps = {
  liked: false,
  disliked: false,
};
